export default "__VITE_ASSET__DU10Axly__"